import { chain } from 'lodash'
import { IModelTipoDoc, ITiposDatosDoc, ITiposDocumento } from 'src/model/candidato-api'

export interface ITipoDoc extends IModelTipoDoc {
  icon: string
  html: string
}

export interface IGrupoDoc {
  label: string
  list: ITipoDoc[]
}

export class TiposDocStore {
  gruposList: IGrupoDoc[]
  tiposDocMap: { [id: string]: ITipoDoc }

  constructor(private tiposDocList: ITiposDocumento) {
    this.gruposList = this.listaTiposDoc(tiposDocList)

    this.tiposDocMap = {}

    chain(this.gruposList)
      .flatMap((g) => g.list)
      .forEach((t) => (this.tiposDocMap[t.tipo] = t))
      .value()
  }

  gruposDocList() {
    return this.gruposList
  }

  private listaTiposDoc(tipos: ITiposDocumento) {
    return tipos.grupos.map((g) => ({
      label: g.label,
      list: g.tipos.map((t) => {
        let _t = t as ITipoDoc

        if (t.required) _t.icon = '/candidato/images/success3.png'

        if (t.notas) {
          _t.html = `<span>${t.texto_en}</span><br/><em>${t.notas}</em>`
        }

        return _t
      }),
    }))
  }
}

export class TiposDocEstadosStore extends TiposDocStore {
  constructor(private tipos: ITiposDatosDoc) {
    super(tipos.tipos)
  }

  estadosStore() {
    return this.tipos.estados
  }
}
